import React from 'react';
import PageHeaderText from 'components/base/page-header-text';

type Props = {
  title?: string;
  description?: string;
  actions?: React.ReactNode;
  filters?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
  showHeader?: boolean;
};

const RequestListLayout = ({
  title,
  description,
  actions,
  filters,
  children,
  className,
  contentClassName,
  showHeader = true
}: Props) => {
  return (
    <div className={className}>
      {showHeader && (title || description || actions) && (
        <PageHeaderText title={title || ''} description={description || ''}>
          {actions}
        </PageHeaderText>
      )}
      {filters}
      <div className={contentClassName}>{children}</div>
    </div>
  );
};

export default RequestListLayout;
